/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiNotificationsIdMutationResponse, DeleteApiNotificationsIdPathParams, DeleteApiNotificationsId400, DeleteApiNotificationsId401, DeleteApiNotificationsId403, DeleteApiNotificationsId404, DeleteApiNotificationsId500 } from "../../types/DeleteApiNotificationsId.ts";
import { deleteApiNotificationsIdMutationResponseSchema } from "../../zod/NotificationSchemas/deleteApiNotificationsIdSchema.ts";

function getDeleteApiNotificationsIdUrl({ id }: { id: DeleteApiNotificationsIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/notifications/${id}` as const }  
  return res
}

/**
 * @summary Удаление PUSH уведомления по идентификатору
 * {@link /api/notifications/:Id}
 */
export async function deleteApiNotificationsId({ id }: { id: DeleteApiNotificationsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiNotificationsIdMutationResponse, ResponseErrorConfig<DeleteApiNotificationsId400 | DeleteApiNotificationsId401 | DeleteApiNotificationsId403 | DeleteApiNotificationsId404 | DeleteApiNotificationsId500>, unknown>({ method : "DELETE", url : getDeleteApiNotificationsIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiNotificationsIdMutationResponseSchema.parse(res.data)
}